// extracted by mini-css-extract-plugin
export var textInput = "_l5-0";